import { Injectable } from '@angular/core';
import { MonoTypeOperatorFunction, Subject, takeUntil } from 'rxjs';

@Injectable()
export class EjournalSessionCancelService {
  private readonly cancelLoading$ = new Subject<void>();

  /**
   * Cancels in-flight subscriptions tied to the current packet/session load.
   */
  cancel(): void {
    this.cancelLoading$.next();
  }

  /**
   * Completes the cancel subject so subscriptions stop after the session is destroyed.
   */
  complete(): void {
    this.cancelLoading$.next();
    this.cancelLoading$.complete();
  }

  /**
   * RxJS operator that unsubscribes when {@link cancel} / {@link complete} fires.
   */
  takeUntilCancel<T>(): MonoTypeOperatorFunction<T> {
    return takeUntil(this.cancelLoading$);
  }
}
